import React from "react";

function IconTemplateList(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.73328 3.95108H10.7999V4.95108H4.73328V3.95108ZM4.73328 6.33914H10.7999V7.33914H4.73328V6.33914ZM4.73328 8.7272H8.53328V9.7272H4.73328V8.7272Z"
        fill="#424242"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16663 1.83334C3.61434 1.83334 3.16663 2.28106 3.16663 2.83334V12.8333C3.16663 13.3856 3.61434 13.8333 4.16663 13.8333H6.66663V14.8333H4.16663C3.06206 14.8333 2.16663 13.9379 2.16663 12.8333V2.83334C2.16663 1.72877 3.06206 0.833344 4.16663 0.833344H11.1666C12.2712 0.833344 13.1666 1.72877 13.1666 2.83334V7.33334H12.1666V2.83334C12.1666 2.28106 11.7189 1.83334 11.1666 1.83334H4.16663Z"
        fill="#424242"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0796 8.53333C14.0096 8.53333 13.9403 8.54712 13.8756 8.57391C13.811 8.60069 13.7521 8.64002 13.7027 8.68949L13.5094 8.88258C13.4602 8.93177 13.4325 8.99852 13.4325 9.06812C13.4325 9.13773 13.4601 9.20449 13.5093 9.25371L13.9045 9.64891C14.007 9.75137 14.1731 9.75137 14.2756 9.64891L14.469 9.4555C14.5689 9.35554 14.625 9.22 14.625 9.07868C14.625 8.93735 14.5688 8.80175 14.4689 8.70178L14.4566 8.68948C14.4071 8.63997 14.3483 8.6007 14.2837 8.57391C14.219 8.54712 14.1497 8.53333 14.0796 8.53333ZM13.1808 9.5822C13.1316 9.53296 13.0648 9.50531 12.9951 9.50536C12.9255 9.5054 12.8587 9.53313 12.8095 9.58243L8.34704 14.0559C8.32272 14.0803 8.30344 14.1092 8.29029 14.141L8.01988 14.7957C7.9794 14.8937 8.00188 15.0064 8.07686 15.0814C8.15183 15.1563 8.26456 15.1788 8.36255 15.1383L9.01718 14.8679C9.049 14.8548 9.07793 14.8355 9.1023 14.8112L13.5758 10.3487C13.6251 10.2995 13.6528 10.2327 13.6529 10.1631C13.6529 10.0935 13.6253 10.0266 13.576 9.9774L13.1808 9.5822Z"
        fill="#424242"
      />
    </svg>
  );
}

export default IconTemplateList;
